import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'lab-ds-skeleton',
  styleUrl: 'lab-ds-skeleton.css',
  shadow: true,
})
export class LabDsSkeleton {
  @Prop() type: 'square' | 'circle' = 'square';

  @Prop() width: string = '100%';

  @Prop() height: string = '100%';

  render() {
    return (
      <div>
        <div style={{ width: this.width, height: this.height }} class={`${this.type === 'square' ? 'v4-skeleton-square' : 'v4-skeleton-circle'}`}></div>
      </div>
    );
  }
}
